import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Text from 'components/common/Text/Text'
import List from 'components/common/List/List'
import Theme from 'components/common/Theme/Theme'
import HTMLContainer from 'components/common/HTMLContainer/HTMLContainer'

const StoreServices = ({ header, description, items = []}) =>
  <React.Fragment>
    {
      header &&
      <SectionName data-at-storeservices-heading narrow headline>{ header }</SectionName>
    }
    {
      description && <Text weight={ 600 }>{ description }</Text>
    }
    <List data-at-storeservices-items>
      {
        items.map(({ serviceName }, index) =>
          serviceName && <Item key={ index }><HTMLContainer inline content={ serviceName } bold /></Item>)
      }
    </List>
  </React.Fragment>

export default StoreServices

StoreServices.propTypes = {
  description: PropTypes.string,
  header: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape)
}

const SectionName = styled(Text)`
  padding: 0 0 10px;
  font-size: 18px;
`

const Item = styled(Text)`
  display: inline-block;
  margin-bottom: 5px;
  color: ${Theme.colors.black};
`
